export default class NoRouteException extends Error {
  constructor(message) {
    super(message);
  }
}
